import { createIcon } from '@chakra-ui/icon';
import * as React from 'react';
export var ExclamationTriangleIcon = createIcon({
  displayName: 'ExclamationTriangleIcon',
  path: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    d: "M11.0404 1.67936C11.4647 0.936833 12.5353 0.936833 12.9596 1.67936L23.0551 19.3464C23.4761 20.0832 22.9441 21 22.0954 21H1.90457C1.05592 21 0.523884 20.0832 0.94493 19.3464L11.0404 1.67936Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.3576 15.808L10.6996 9.116L13.3036 9.13L12.6316 15.808H11.3576ZM10.8676 16.76H13.1356V19H10.8676V16.76Z",
    fill: "white"
  }))
});
//# sourceMappingURL=ExclamationTriangle.js.map